/* Лимит страниц для записей */

export const AUTH_KEY = 'REACT_TOKEN_AUTH_KEY';
export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const CHAT_VIEW = 'CHAT_VIEW';
